import React, { useEffect, useState } from "react";
import gzr from "../assets/gzr.png";
import gas from "../assets/gas.png";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import { Button, Container, Box } from "@mui/material";
import {
  fetchPlans
} from "../assets/data";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import CheckCircleOutlineRoundedIcon from "@mui/icons-material/CheckCircleOutlineRounded";
import { useSnackbar } from "notistack";
import Modal from "@mui/material/Modal";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import ArrowBackIosRoundedIcon from "@mui/icons-material/ArrowBackIosRounded";
import useMediaQuery from "@mui/material/useMediaQuery";
import { API_BASE_URL } from "../components/Config";
import axios from "axios";
import Cookies from "js-cookie";
import "./dashboard.css";
import { display } from "@mui/system";
function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <div>{children}</div>
        </Box>
      )}
    </div>
  );
}
CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};
function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
function CheckBox({ label }) {
  const [isChecked, setIsChecked] = useState(false);

  const handleClick = () => {
    setIsChecked(!isChecked);
  };

  return (
    <div className="chacked_dashboard" onClick={handleClick}>
      <div className={`dot_div ${isChecked ? "checked" : ""}`}>
        <div></div>
      </div>
      <p>{label}</p>
    </div>
  );
}
const DashboardHome = () => {
  const [value, setValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const [plans, setPlans] = useState([]);
  console.log(plans, "myplans");
  
  const { enqueueSnackbar } = useSnackbar();
  const [read, setRead] = useState(false);
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [cardModal1, setCardModal1] = useState(false);
  const [cardModal2, setCardModal2] = useState(false);
  const [cardModal3, setCardModal3] = useState(false);
  const [cardModal4, setCardModal4] = useState(false);
  const [axpended, setAxpended] = useState(false);
  const [descriptions, setDescriptions] = useState({});
  const [planChoices, setPlanChoices] = useState([]);
  const [isChecked, setIsChecked] = useState(false);


  const handleDescriptionChange = (id, value) => {
    console.log(id, value, "id, value");
    setDescriptions(prevDescriptions => ({
      ...prevDescriptions,
      [id]: value,
    }));
    console.log(descriptions, "descriptions");
  };

  const handleCheckBoxChange = (label, isChecked) => {
    setIsChecked((prevState) => !prevState);
    setPlanChoices([...planChoices, label]);
  };
  const [visibleCards, setVisibleCards] = useState({
    boiler: false,
    boilerPlus: false,
    heating: false,
    homePlus: false,
  });
  useEffect(() => {
    const loadPlans = async () => {
      const apiPlans = await fetchPlans();
      setPlans(apiPlans);
      console.log(apiPlans, "apiPlansapiPlans")



        const activePlan = apiPlans[0].title;
        console.log(apiPlans ,"activePlan");
        const newVisibleCards = {
          boiler: false,
          boilerPlus: false,
          heating: false,
          homePlus: false,
        };

        switch (activePlan) {
          case "Boiler":
          case "Boiler Install":
            newVisibleCards.boiler = true;
            break;
          case "Boiler+":
            newVisibleCards.boilerPlus = true;
            break;
          case "Heating+":
          case "Heating":
            newVisibleCards.heating = true;
            break;
          case "Home+":
          case "Home":
            newVisibleCards.homePlus = true;
            break;
          default:
            break;
        }


        setVisibleCards(newVisibleCards);

      
    };

    loadPlans();
  
  }, []);

  useEffect(() => {
    console.log("Updated visibleCards:", visibleCards);
  }, [visibleCards]);



  const handelCards = () => {
    setAxpended(!axpended);

    const cardElements = document.querySelectorAll(".cards_actions");

    console.log(axpended , "axpended")
    console.log(cardElements , "cardElements")

    cardElements.forEach((element) => {
      element.style.marginTop = axpended == true ? "0rem" : "7rem";
    });
  };
  
  const match1990 = useMediaQuery("(max-width:450px)");
  const checkEidth = window.innerWidth;

  useEffect(() => {
    if (checkEidth <= 450) {
      setAxpended(true);
    } else {
      setAxpended(false);
    }
  }, [checkEidth]);

  const simulateAPIRequest = async (url, method, data) => {
    try {
      const token = Cookies.get("token");
      const response = await axios({
        method,
        url,
        data,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      console.log("data is : ", response.data);
      return response.data;
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        throw new Error(error.response.data.message);
      } else {
        throw new Error("An error occurred");
      }
    }
  };

  const handleDocumentDownload = async () => {
    try {
      const url = `${API_BASE_URL}/customer/document/`;
      const response = await axios({
        method: "GET",
        url,
        responseType: "blob",
      });

      const contentDisposition = response.headers["content-disposition"];
      let filename = "Terms&Conditions.pdf";

      if (
        contentDisposition &&
        contentDisposition.indexOf("attachment") !== -1
      ) {
        const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
        const matches = filenameRegex.exec(contentDisposition);
        if (matches != null && matches[1]) {
          filename = matches[1].replace(/['"]/g, "");
        }
      }

      const blob = new Blob([response.data], {
        type: response.headers["content-type"],
      });
      const downloadUrl = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = downloadUrl;
      link.setAttribute("download", filename);
      document.body.appendChild(link);

      link.click();

      window.URL.revokeObjectURL(downloadUrl);
      document.body.removeChild(link);
    } catch (error) {
      console.error("Failed to download document:", error);
      enqueueSnackbar("Failed to download document", { variant: "error" });
    }
  };

  const handlePopup = async (name, popup_name, textarea) => {
    if (!descriptions || planChoices.length === 0) {
      enqueueSnackbar("Please fill in all fields", { variant: "error" });
      return;
    }
    if (popup_name === "1") {
      setCardModal1(false);
    }
    const url = `${API_BASE_URL}/plans/popup/`;
    const method = "POST";
    console.log(descriptions , "descriptionsdescriptions");
    const data = {
      title: `User Request: ${name}`,
      description: descriptions[textarea],
      planChoices: `${planChoices}`,
    };
    console.log("data is: ", data);

    try {
      await simulateAPIRequest(url, method, data);
      enqueueSnackbar(
        "Your request is created successfully our agent will be in touch with you through email soon.",
        { variant: "success" }
      );
      if (popup_name === "1") {
        setCardModal1(false);
      }
      else if (popup_name === "2") {
        setCardModal2(false);
      }
      else if (popup_name === "3") {
        setCardModal3(false);
      }
      else if (popup_name === "4") {
        setCardModal4(false);
      }

      // window.location.href = window.location.href;
    } catch (error) {
      enqueueSnackbar(error.message, { variant: "error" });
    }
    setPlanChoices([])
    setDescriptions({})
  };

  return (
    <>
      <div className="padi_dashboard">
        <Container maxWidth="xl" className="container_dashboard">

        <div className="welcom_dashboard">
            <h1>Welcome!</h1>
            <p>How can we help you today?</p>
          </div>
          <div>
            <div className="main_dhashboerd_home_page">
              <div className="dashbord_home_cards">
                <div>
                  <h1 className="book-repair">Book Repair</h1>

                  <div className="dashboard_card_boiler">
                    {Object.entries({
                      boiler: "Boiler",
                      boilerPlus: "Boiler+",
                      heating: "Heating+",
                      homePlus: "Home+",
                    }).map(([key, label]) => (
                      <div
                        key={label}
                        className="boiler_home_card"
                        onClick={() => {
                       
                          if (visibleCards[key]) {
                            // Modify the onClick handler for each card as needed
                            if (key === "boiler") setCardModal1(!cardModal1);
                            if (key === "boilerPlus") setCardModal2(!cardModal2);
                            if (key === "heating") setCardModal3(!cardModal3);
                            if (key === "homePlus") setCardModal4(!cardModal4);
                          }
                        }}
                        style={{
                          opacity: visibleCards[key] ? 1 : 0.5,
                          filter: visibleCards[key] ? "none" : "blur(2px)",
                          pointerEvents: visibleCards[key] ? "auto" : "none",
                          transition: "opacity 0.2s ease, filter 0.3s ease",
                        }}
                      >
                        <img src={key === "homePlus" ? gas : gzr} alt="" />
                        <p>{label}</p>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              <div
                className="box_celected_plans dashboard_plans_selected"
                style={{ height: axpended ? "150px" : "auto" }}
              >
                {plans?.map((item, i) => (
                  <div key={i} className="card_content_inside">
                    <div className="selected_plan_div">
                      <span>
                        <p>{item?.sel}</p>
                        <h1>{item?.title}</h1>
                        <p className="m-0">{item?.ser}</p>
                      </span>
                      <img src={gzr} alt="icons" />
                    </div>
                    <div className="cards_actions mt">
                      <div className="cards_actions">
                        {item?.working.map((item, i) => (
                          <div className="working" key={i}>
                            <CheckCircleOutlineRoundedIcon className="iconmark" />
                            {item}
                          </div>
                        ))}
                      </div>
                      <div className="cards_actions">
                        {item?.notworking?.map((item, i) => (
                          <div className="notwarking" key={i}>
                            <CancelOutlinedIcon className="notwar" />
                            <span className="spanundesr">{item}</span>
                          </div>
                        ))}
                      </div>
                      <div className="view_div">
                        <p>
                          Review what is covered in your WeCare policy, and what
                          is not. <span onClick={handleOpen}>View here</span>
                        </p>
                        <Modal
                          open={open}
                          onClose={handleClose}
                          aria-labelledby="modal-modal-title"
                          aria-describedby="modal-modal-description"
                        >
                          <div className="modal_find">
                            <div className="find_close">
                              <IconButton>
                                <CloseIcon onClick={handleClose} />
                              </IconButton>
                            </div>
                            <div>
                              <Tabs
                                value={value}
                                onChange={handleChange}
                                aria-label="basic ta bs example"
                                className="main_tabs"
                              >
                                <Tab
                                  label="Covered"
                                  {...a11yProps(0)}
                                  className="tabeBtn"
                                />
                                <Tab
                                  label="Not Covered"
                                  {...a11yProps(1)}
                                  className="tabeBtn"
                                />
                              </Tabs>
                            </div>
                            <div className="find_tabs">
                              <CustomTabPanel value={value} index={0}>
                                <div className="cards_actions">
                                  {item?.working.map((item, i) => (
                                    <div className="working" key={i}>
                                      <CheckCircleOutlineRoundedIcon className="iconmark" />{" "}
                                      <span className="notcovering">
                                        {" "}
                                        {item}
                                      </span>
                                    </div>
                                  ))}
                                </div>
                              </CustomTabPanel>
                              <CustomTabPanel value={value} index={1}>
                                <div className="cards_actions">
                                  <div className="notwarking">
                                    <CancelOutlinedIcon className="notwar" />
                                    <span className="notcovering">
                                      Gas supply pipe, boiler flue
                                    </span>
                                  </div>
                                </div>
                                <div className="cards_actions">
                                  <div className="notwarking">
                                    <CancelOutlinedIcon className="notwar" />
                                    <span className="notcovering">
                                      Intermittent, pre-existing, or design
                                      faults which includes Removal of
                                      limescale, sludge or debris
                                    </span>
                                  </div>
                                </div>
                                <div className="cards_actions">
                                  <div className="notwarking">
                                    <CancelOutlinedIcon className="notwar" />
                                    <span className="notcovering">
                                      Please see Terms and Conditions document
                                      for full details of what's covered and
                                      what's not covered.
                                    </span>
                                  </div>
                                </div>
                              </CustomTabPanel>
                            </div>
                            <div className="btnFounds">
                              <Button
                                variant="outlined"
                                onClick={handleDocumentDownload}
                              >
                                Download Terms & Conditions
                              </Button>
                            </div>
                          </div>
                        </Modal>
                      </div>
                    </div>
                    <div className="month_div">
                       <h1>{item.isFixedPrice ? 'Total Price' : item?.month}</h1>
                      <span className="d-flex align-items-baseline">
                        <h2>{item?.price}</h2>{item.isFixedPrice ? '' : 'p/m'}
                      </span>
                    </div>
                    <p className="desc_dabid">
                      The initial direct debit payment will be requested in the
                      upcoming 14 days. Your policy agreement spans a duration
                      of 12 months.{" "}
                      {read || (
                        <span
                          className="read_btn"
                          onClick={() => setRead(true)}
                        >
                          Read More
                        </span>
                      )}
                    </p>
                    {read && (
                      <div className="read_more">
                        <p className="reading">
                          We will reach out to you well in advance of your
                          agreement renewal date. Your agreement is set to renew
                          automatically unless you opt to cancel. This automatic
                          renewal is designed to maintain continuous coverage
                          for you. If you prefer not to proceed with automatic
                          renewal, feel free to get in touch with us to opt out.{" "}
                          <span
                            className="read_btn"
                            onClick={() => setRead(false)}
                          >
                            Read Less
                          </span>
                        </p>
                      </div>
                    )}
                    <div className="month_div">
                      <h1>{item?.serv}</h1>
                      <span className="d-flex align-items-baseline">
                        <h2>{item?.fee}</h2>
                      </span>
                    </div>
                    <p className="desc_dabid">
                      The service fee is the charge incurred each time you seek
                      a repair. You have the flexibility to select a plan with
                      or without a service request fee. Opting for a higher
                      service request fee lowers your monthly payments.
                    </p>
                    {axpended ? (
                      <button className="icons_expended" onClick={handelCards}>
                        {" "}
                        <ArrowBackIosRoundedIcon />
                      </button>
                    ) : null}
                  </div>
                ))}
                <button className="icons_expended_bot" onClick={handelCards}>
                  {" "}
                  <ArrowBackIosRoundedIcon />
                </button>
              </div>
            </div>
          </div>





          {/* boiler */}
          <Modal
            open={cardModal1}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <div className="main_modal_dashboard">
              <div className="icons_close_dashboard">
                <IconButton onClick={() => setCardModal1(false)}>
                  <CloseIcon />
                </IconButton>
              </div>
              <div className="main_div_dash_modal">
                <div className="describ_box">
                  <h1>Book Repair</h1>
                  <div>
                    <h6>Boiler</h6>
                    <textarea
                      cols="35"
                      rows="8"
                      className="text_areas"
                      value={descriptions["textarea1"] || ""}
                      onChange={(e) => handleDescriptionChange("textarea1", e.target.value)}
                      placeholder="Repair Description"
                    />
                  </div>
                  <div className="checkdiv">
                    <div className="checkdiv_content">
                      <label className="checkbox_label">
                        <input
                          className="checkbox_input"
                          type="checkbox"
                          isChecked={isChecked}
                          onChange={(e) =>
                            handleCheckBoxChange(
                              "Boiler Breakdown",
                              e.target.value
                            )
                          }
                        />
                        Boiler Breakdown
                      </label>
                    </div>
                  </div>
                  <Button
                    variant="contained"
                    className="paymint_btn"
                    onClick={() => handlePopup("Boiler", "1", "textarea1")}
                  >
                    Book Repair
                  </Button>
                  <p className="members">
                    A member of the WeCare team will be in touch via email to
                    confirm your booking.
                  </p>
                </div>
                <div
                  className="box_celected_plans "
                  style={{ height: axpended ? "150px" : "auto" }}
                >
                  {axpended ? (
                    <button className="icons_expended" onClick={handelCards}>
                      {" "}
                      <ArrowBackIosRoundedIcon />
                    </button>
                  ) : null}
                  {plans?.map((item, i) => (
                    <div key={i}>
                      <div className="selected_plan_div">
                        <span>
                          <p>{item?.sel}</p>
                          <h1>{item?.title} </h1>
                          <p className="m-0">{item?.ser}</p>
                        </span>
                        <img src={gzr} alt="icons" />
                      </div>
                      <div className="cards_actions mt">
                        <div className="cards_actions">
                          {item?.working.map((item, i) => (
                            <div className="working" key={i}>
                              <CheckCircleOutlineRoundedIcon className="iconmark" />
                              {item}
                            </div>
                          ))}
                        </div>
                        <div className="cards_actions">
                          {item?.notworking?.map((item, i) => (
                            <div className="notwarking" key={i}>
                              <CancelOutlinedIcon className="notwar" />
                              <span className="spanundesr">{item}</span>
                            </div>
                          ))}
                        </div>
                        <div className="view_div">
                          <p>
                            Review what is covered in your WeCare policy, and
                            what is not.{" "}
                            <span onClick={handleOpen}>View here</span>
                          </p>
                          <Modal
                            open={open}
                            onClose={handleClose}
                            aria-labelledby="modal-modal-title"
                            aria-describedby="modal-modal-description"
                          >
                            <div className="modal_find">
                              <div className="find_close">
                                <IconButton onClick={handleClose}>
                                  <CloseIcon />
                                </IconButton>
                              </div>
                              <div>
                                <Tabs
                                  value={value}
                                  onChange={handleChange}
                                  aria-label="basic ta bs example"
                                  className="main_tabs"
                                >
                                  <Tab
                                    label="Covered"
                                    {...a11yProps(0)}
                                    className="tabeBtn"
                                  />
                                  <Tab
                                    label="Not Covered"
                                    {...a11yProps(1)}
                                    className="tabeBtn"
                                  />
                                </Tabs>
                              </div>
                              <div className="find_tabs">
                                <CustomTabPanel value={value} index={0}>
                                  <div className="cards_actions">
                                    {item?.working.map((item, i) => (
                                      <div className="working" key={i}>
                                        <CheckCircleOutlineRoundedIcon className="iconmark" />{" "}
                                        {item}
                                      </div>
                                    ))}
                                  </div>
                                </CustomTabPanel>
                                <CustomTabPanel value={value} index={1}>
                                  <div className="cards_actions">
                                    <div className="notwarking">
                                      <CancelOutlinedIcon className="notwar" />
                                      <span className="notcovering">
                                        Gas supply pipe, boiler flue
                                      </span>
                                    </div>
                                  </div>
                                  <div className="cards_actions">
                                    <div className="notwarking">
                                      <CancelOutlinedIcon className="notwar" />
                                      <span className="notcovering">
                                        Intermittent, pre-existing, or design
                                        faults which includes Removal of
                                        limescale, sludge or debris
                                      </span>
                                    </div>
                                  </div>
                                  <div className="cards_actions">
                                    <div className="notwarking">
                                      <CancelOutlinedIcon className="notwar" />
                                      <span className="notcovering">
                                        Please see Terms and Conditions document
                                        for full details of what's covered and
                                        what's not covered.
                                      </span>
                                    </div>
                                  </div>
                                </CustomTabPanel>
                              </div>
                              <div className="btnFounds">
                                <Button
                                  variant="outlined"
                                  onClick={handleDocumentDownload}
                                >
                                  Download Terms & Conditions
                                </Button>
                              </div>
                            </div>
                          </Modal>
                        </div>
                      </div>
                      <div className="month_div">
                         <h1>{item.isFixedPrice ? 'Total Price' : item?.month}</h1>
                        <span className="d-flex align-items-baseline">
                          <h2>{item?.price}</h2>{item.isFixedPrice ? '' : 'p/m'}
                        </span>
                      </div>
                      <p className="desc_dabid">
                        The initial direct debit payment will be requested in
                        the upcoming 14 days. Your policy agreement spans a
                        duration of 12 months.{" "}
                        {read || (
                          <span
                            className="read_btn"
                            onClick={() => setRead(true)}
                          >
                            Read More
                          </span>
                        )}
                      </p>
                      {read && (
                        <div className="read_more">
                          <p className="reading">
                            We will reach out to you well in advance of your
                            agreement renewal date. Your agreement is set to
                            renew automatically unless you opt to cancel. This
                            automatic renewal is designed to maintain continuous
                            coverage for you. If you prefer not to proceed with
                            automatic renewal, feel free to get in touch with us
                            to opt out.{" "}
                            <span
                              className="read_btn"
                              onClick={() => setRead(false)}
                            >
                              Read Less
                            </span>
                          </p>
                        </div>
                      )}
                      <div className="month_div">
                        <h1>{item?.serv}</h1>
                        <span className="d-flex align-items-baseline">
                          <h2>{item?.fee}</h2>
                        </span>
                      </div>
                      <p className="desc_dabid">
                        The service fee is the charge incurred each time you
                        seek a repair. You have the flexibility to select a plan
                        with or without a service request fee. Opting for a
                        higher service request fee lowers your monthly payments.
                      </p>
                    </div>
                  ))}
                  <button className="icons_expended_bot" onClick={handelCards}>
                    {" "}
                    <ArrowBackIosRoundedIcon />
                  </button>
                </div>
              </div>
            </div>
          </Modal>

          {/* boiler+ */}

          <Modal
            open={cardModal2}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <div className="main_modal_dashboard">
              <div className="icons_close_dashboard">
                <IconButton onClick={() => setCardModal2(false)}>
                  <CloseIcon />
                </IconButton>
              </div>
              <div className="main_div_dash_modal">
                <div className="describ_box">
                  <h1>Book Repair</h1>
                  <div>
                    <h6>Boiler +</h6>
                    <textarea
                      cols="35"
                      rows="8"
                      className="text_areas"
                      placeholder="Repair Description"
                      value={descriptions["textarea2"] || ""}
                      onChange={(e) => handleDescriptionChange("textarea2", e.target.value)}
                    ></textarea>
                  </div>
                  <div className="checkdiv">
                    {/* <CheckBox label="Boiler Breakdown" />
                    <CheckBox label="Annual Boiler Service" /> */}
                    <label className="checkbox_label">
                      <input
                        className="checkbox_input"
                        type="checkbox"
                        isChecked={isChecked}
                        onChange={(e) =>
                          handleCheckBoxChange(
                            "Boiler Breakdown",
                            e.target.value
                          )
                        }
                      />
                      Boiler Breakdown
                    </label>{" "}
                    <br />
                    <label className="checkbox_label">
                      <input
                        className="checkbox_input"
                        type="checkbox"
                        isChecked={isChecked}
                        onChange={(e) =>
                          handleCheckBoxChange(
                            "Annual Boiler Service",
                            e.target.value
                          )
                        }
                      />
                      Annual Boiler Service
                    </label>
                  </div>
                  <Button
                    variant="contained"
                    className="paymint_btn "
                    onClick={() => handlePopup("Boiler+", "2", "textarea2")}
                  >
                    Book Repair
                  </Button>
                  <p className="members">
                    A member of the WeCare team will be in touch via email to
                    confirm your booking.
                  </p>
                </div>
                <div
                  className="box_celected_plans "
                  style={{ height: axpended ? "150px" : "auto" }}
                >
                  {axpended ? (
                    <button className="icons_expended" onClick={handelCards}>
                      {" "}
                      <ArrowBackIosRoundedIcon />
                    </button>
                  ) : null}
                  {plans?.map((item, i) => (
                    <div key={i}>
                      <div className="selected_plan_div">
                        <span>
                          <p>{item?.sel}</p>
                          <h1>
                            {item?.title} <span className="icone_name">+</span>
                          </h1>
                          <p className="m-0">{item?.ser}</p>
                        </span>
                        <img src={gzr} alt="icons" />
                      </div>
                      <div className="cards_actions mt">
                        <div className="cards_actions">
                          {item?.working.map((item, i) => (
                            <div className="working" key={i}>
                              <CheckCircleOutlineRoundedIcon className="iconmark" />
                              {item}
                            </div>
                          ))}
                        </div>
                        <div className="cards_actions">
                          {item?.notworking?.map((item, i) => (
                            <div className="notwarking" key={i}>
                              <CancelOutlinedIcon className="notwar" />
                              <span className="spanundesr">{item}</span>
                            </div>
                          ))}
                        </div>
                        <div className="view_div">
                          <p>
                            Review what is covered in your WeCare policy, and
                            what is not.{" "}
                            <span onClick={handleOpen}>View here</span>
                          </p>
                          <Modal
                            open={open}
                            onClose={handleClose}
                            aria-labelledby="modal-modal-title"
                            aria-describedby="modal-modal-description"
                          >
                            <div className="modal_find">
                              <div className="find_close">
                                <IconButton onClick={handleClose}>
                                  <CloseIcon />
                                </IconButton>
                              </div>
                              <div>
                                <Tabs
                                  value={value}
                                  onChange={handleChange}
                                  aria-label="basic ta bs example"
                                  className="main_tabs"
                                >
                                  <Tab
                                    label="Covered"
                                    {...a11yProps(0)}
                                    className="tabeBtn"
                                  />
                                  <Tab
                                    label="Not Covered"
                                    {...a11yProps(1)}
                                    className="tabeBtn"
                                  />
                                </Tabs>
                              </div>
                              <div className="find_tabs">
                                <CustomTabPanel value={value} index={0}>
                                  <div className="cards_actions">
                                    {item?.working.map((item, i) => (
                                      <div className="working" key={i}>
                                        <CheckCircleOutlineRoundedIcon className="iconmark" />{" "}
                                        {item}
                                      </div>
                                    ))}
                                  </div>
                                </CustomTabPanel>
                                <CustomTabPanel value={value} index={1}>
                                  <div className="cards_actions">
                                    <div className="notwarking">
                                      <CancelOutlinedIcon className="notwar" />
                                      <span className="notcovering">
                                        Gas supply pipe, boiler flue
                                      </span>
                                    </div>
                                  </div>
                                  <div className="cards_actions">
                                    <div className="notwarking">
                                      <CancelOutlinedIcon className="notwar" />
                                      <span className="notcovering">
                                        Intermittent, pre-existing, or design
                                        faults which includes Removal of
                                        limescale, sludge or debris
                                      </span>
                                    </div>
                                  </div>
                                  <div className="cards_actions">
                                    <div className="notwarking">
                                      <CancelOutlinedIcon className="notwar" />
                                      <span className="notcovering">
                                        Please see Terms and Conditions document
                                        for full details of what's covered and
                                        what's not covered.
                                      </span>
                                    </div>
                                  </div>
                                </CustomTabPanel>
                              </div>
                              <div className="btnFounds">
                                <Button
                                  variant="outlined"
                                  onClick={handleDocumentDownload}
                                >
                                  Download Terms & Conditions
                                </Button>
                              </div>
                            </div>
                          </Modal>
                        </div>
                      </div>
                      <div className="month_div">
                         <h1>{item.isFixedPrice ? 'Total Price' : item?.month}</h1>
                        <span className="d-flex align-items-baseline">
                          <h2>{item?.price}</h2>{item.isFixedPrice ? '' : 'p/m'}
                        </span>
                      </div>
                      <p className="desc_dabid">
                        The initial direct debit payment will be requested in
                        the upcoming 14 days. Your policy agreement spans a
                        duration of 12 months.{" "}
                        {read || (
                          <span
                            className="read_btn"
                            onClick={() => setRead(true)}
                          >
                            Read More
                          </span>
                        )}
                      </p>
                      {read && (
                        <div className="read_more">
                          <p className="reading">
                            We will reach out to you well in advance of your
                            agreement renewal date. Your agreement is set to
                            renew automatically unless you opt to cancel. This
                            automatic renewal is designed to maintain continuous
                            coverage for you. If you prefer not to proceed with
                            automatic renewal, feel free to get in touch with us
                            to opt out.{" "}
                            <span
                              className="read_btn"
                              onClick={() => setRead(false)}
                            >
                              Read Less
                            </span>
                          </p>
                        </div>
                      )}
                      <div className="month_div">
                        <h1>{item?.serv}</h1>
                        <span className="d-flex align-items-baseline">
                          <h2>{item?.fee}</h2>
                        </span>
                      </div>
                      <p className="desc_dabid">
                        The service fee is the charge incurred each time you
                        seek a repair. You have the flexibility to select a plan
                        with or without a service request fee. Opting for a
                        higher service request fee lowers your monthly payments.
                      </p>
                    </div>
                  ))}
                  <button className="icons_expended_bot" onClick={handelCards}>
                    {" "}
                    <ArrowBackIosRoundedIcon />
                  </button>
                </div>
              </div>
            </div>
          </Modal>

          {/* heating+ */}

          <Modal
            open={cardModal3}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <div className="main_modal_dashboard">
              <div className="icons_close_dashboard">
                <IconButton onClick={() => setCardModal3(false)}>
                  <CloseIcon />
                </IconButton>
              </div>
              <div className="main_div_dash_modal">
                <div className="describ_box">
                  <h1>Book Repair</h1>
                  <div>
                    <h6>Heating +</h6>
                    <textarea
                      cols="35"
                      rows="8"
                      className="text_areas"
                      placeholder="Repair Description"
                      value={descriptions["textarea3"] || ""}
                      onChange={(e) => handleDescriptionChange("textarea3", e.target.value)}
                    ></textarea>
                  </div>
                  <div className="checkdiv">
                    <div className="checkdiv_content">
                      <label className="checkbox_label">
                        <input
                          className="checkbox_input"
                          type="checkbox"
                          isChecked={isChecked}
                          onChange={(e) =>
                            handleCheckBoxChange(
                              "Boiler Breakdown",
                              e.target.value
                            )
                          }
                        />
                        Boiler Breakdown
                      </label>{" "}
                    </div>
 
                    <div className="checkdiv_content">
                      <label className="checkbox_label">
                        <input
                          className="checkbox_input"
                          type="checkbox"
                          isChecked={isChecked}
                          onChange={(e) =>
                            handleCheckBoxChange(
                              "Annual Boiler Service",
                              e.target.value
                            )
                          }
                        />
                        Annual Boiler Service
                      </label>{" "}
                    </div>

                    <div className="checkdiv_content">
                      <label className="checkbox_label">
                        <input
                          className="checkbox_input"
                          type="checkbox"
                          isChecked={isChecked}
                          onChange={(e) =>
                            handleCheckBoxChange(
                              "Central Heating System",
                              e.target.value
                            )
                          }
                        />
                        Central Heating System
                      </label>
                    </div>
                  </div>
                  <Button
                    variant="contained"
                    className="paymint_btn "
                    onClick={() => handlePopup("Heating", "3", "textarea3")}
                  >
                    Book Repair
                  </Button>
                  <p className="members">
                    A member of the WeCare team will be in touch via email to
                    confirm your booking.
                  </p>
                </div>
                <div
                  className="box_celected_plans "
                  style={{ height: axpended ? "150px" : "auto" }}
                >
                  {axpended ? (
                    <button className="icons_expended" onClick={handelCards}>
                      {" "}
                      <ArrowBackIosRoundedIcon />
                    </button>
                  ) : null}
                  {plans?.map((item, i) => (
                    <div key={i}>
                      <div className="selected_plan_div">
                        <span>
                          <p>{item?.sel}</p>
                          <h1>
                            {item?.title} <span className="icone_name">+</span>
                          </h1>
                          <p className="m-0">{item?.ser}</p>
                        </span>
                        <img src={gzr} alt="icons" />
                      </div>
                      <div className="cards_actions mt">
                        <div className="cards_actions">
                          {item?.working.map((item, i) => (
                            <div className="working" key={i}>
                              <CheckCircleOutlineRoundedIcon className="iconmark" />
                              {item}
                            </div>
                          ))}
                        </div>
                        <div className="cards_actions">
                          {item?.notworking?.map((item, i) => (
                            <div className="notwarking" key={i}>
                              <CancelOutlinedIcon className="notwar" />
                              <span className="spanundesr">{item}</span>
                            </div>
                          ))}
                        </div>
                        <div className="view_div">
                          <p>
                            Review what is covered in your WeCare policy, and
                            what is not.{" "}
                            <span onClick={handleOpen}>View here</span>
                          </p>
                          <Modal
                            open={open}
                            onClose={handleClose}
                            aria-labelledby="modal-modal-title"
                            aria-describedby="modal-modal-description"
                          >
                            <div className="modal_find">
                              <div className="find_close">
                                <IconButton onClick={handleClose}>
                                  <CloseIcon />
                                </IconButton>
                              </div>
                              <div>
                                <Tabs
                                  value={value}
                                  onChange={handleChange}
                                  aria-label="basic ta bs example"
                                  className="main_tabs"
                                >
                                  <Tab
                                    label="Covered"
                                    {...a11yProps(0)}
                                    className="tabeBtn"
                                  />
                                  <Tab
                                    label="Not Covered"
                                    {...a11yProps(1)}
                                    className="tabeBtn"
                                  />
                                </Tabs>
                              </div>
                              <div className="find_tabs">
                                <CustomTabPanel value={value} index={0}>
                                  <div className="cards_actions">
                                    {item?.working.map((item, i) => (
                                      <div className="working" key={i}>
                                        <CheckCircleOutlineRoundedIcon className="iconmark" />{" "}
                                        {item}
                                      </div>
                                    ))}
                                  </div>
                                </CustomTabPanel>
                                <CustomTabPanel value={value} index={1}>
                                  <div className="cards_actions">
                                    <div className="notwarking">
                                      <CancelOutlinedIcon className="notwar" />
                                      <span className="notcovering">
                                        Gas supply pipe, boiler flue
                                      </span>
                                    </div>
                                  </div>
                                  <div className="cards_actions">
                                    <div className="notwarking">
                                      <CancelOutlinedIcon className="notwar" />
                                      <span className="notcovering">
                                        Intermittent, pre-existing, or design
                                        faults which includes Removal of
                                        limescale, sludge or debris
                                      </span>
                                    </div>
                                  </div>
                                  <div className="cards_actions">
                                    <div className="notwarking">
                                      <CancelOutlinedIcon className="notwar" />
                                      <span className="notcovering">
                                        Please see Terms and Conditions document
                                        for full details of what's covered and
                                        what's not covered.
                                      </span>
                                    </div>
                                  </div>
                                </CustomTabPanel>
                              </div>
                              <div className="btnFounds">
                                <Button
                                  variant="outlined"
                                  onClick={handleDocumentDownload}
                                >
                                  Download Terms & Conditions
                                </Button>
                              </div>
                            </div>
                          </Modal>
                        </div>
                      </div>
                      <div className="month_div">
                         <h1>{item.isFixedPrice ? 'Total Price' : item?.month}</h1>
                        <span className="d-flex align-items-baseline">
                          <h2>{item?.price}</h2>{item.isFixedPrice ? '' : 'p/m'}
                        </span>
                      </div>
                      <p className="desc_dabid">
                        The initial direct debit payment will be requested in
                        the upcoming 14 days. Your policy agreement spans a
                        duration of 12 months.{" "}
                        {read || (
                          <span
                            className="read_btn"
                            onClick={() => setRead(true)}
                          >
                            Read More
                          </span>
                        )}
                      </p>
                      {read && (
                        <div className="read_more">
                          <p className="reading">
                            We will reach out to you well in advance of your
                            agreement renewal date. Your agreement is set to
                            renew automatically unless you opt to cancel. This
                            automatic renewal is designed to maintain continuous
                            coverage for you. If you prefer not to proceed with
                            automatic renewal, feel free to get in touch with us
                            to opt out.{" "}
                            <span
                              className="read_btn"
                              onClick={() => setRead(false)}
                            >
                              Read Less
                            </span>
                          </p>
                        </div>
                      )}
                      <div className="month_div">
                        <h1>{item?.serv}</h1>
                        <span className="d-flex align-items-baseline">
                          <h2>{item?.fee}</h2>
                        </span>
                      </div>
                      <p className="desc_dabid">
                        The service fee is the charge incurred each time you
                        seek a repair. You have the flexibility to select a plan
                        with or without a service request fee. Opting for a
                        higher service request fee lowers your monthly payments.
                      </p>
                    </div>
                  ))}
                  <button className="icons_expended_bot" onClick={handelCards}>
                    {" "}
                    <ArrowBackIosRoundedIcon />
                  </button>
                </div>
              </div>
            </div>
          </Modal>

          {/* Home +*/}

          <Modal
            open={cardModal4}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <div className="main_modal_dashboard">
              <div className="icons_close_dashboard">
                <IconButton onClick={() => setCardModal4(false)}>
                  <CloseIcon />
                </IconButton>
              </div>
              <div className="main_div_dash_modal">
                <div className="describ_box">
                  <h1>Book Repair</h1>
                  <div>
                    <h6>Home +</h6>
                    <textarea
                      cols="35"
                      rows="8"
                      className="text_areas"
                      placeholder="Repair Description"
                      value={descriptions["textarea4"] || ""}
                      onChange={(e) => handleDescriptionChange("textarea4", e.target.value)}
                    ></textarea>
                  </div>
                  <div className="checkdiv">

        
                    <label className="checkbox_label">
                      <input
                        className="checkbox_input"
                        type="checkbox"
                        isChecked={isChecked}
                        onChange={(e) =>
                          handleCheckBoxChange(
                            "Boiler Breakdown",
                            e.target.value
                          )
                        }
                      />
                      Boiler Breakdown
                    </label>{" "}
                    <br />
                    <label className="checkbox_label">
                      <input
                        className="checkbox_input"
                        type="radio"
                        isChecked={isChecked}
                        onChange={(e) =>
                          handleCheckBoxChange(
                            "Annual Boiler Service",
                            e.target.value
                          )
                        }
                      />
                      Annual Boiler Service
                    </label>{" "}
                    <br />
                    <label className="checkbox_label">
                      <input
                        className="checkbox_input"
                        type="checkbox"
                        isChecked={isChecked}
                        onChange={(e) =>
                          handleCheckBoxChange(
                            "Central Heating System",
                            e.target.value
                          )
                        }
                      />
                      Central Heating System
                    </label>{" "}
                    <br />
                    <label className="checkbox_label">
                      <input
                        className="checkbox_input"
                        type="checkbox"
                        isChecked={isChecked}
                        onChange={(e) =>
                          handleCheckBoxChange("Plumbing", e.target.value)
                        }
                      />
                      Plumbing
                    </label>{" "}
                    <br />
                    <label className="checkbox_label">
                      <input
                        className="checkbox_input"
                        type="checkbox"
                        isChecked={isChecked}
                        onChange={(e) =>
                          handleCheckBoxChange("Drainage", e.target.value)
                        }
                      />
                      Drainage
                    </label>{" "}
                    <br />
                    <label className="checkbox_label">
                      <input
                        className="checkbox_input"
                        type="checkbox"
                        isChecked={isChecked}
                        onChange={(e) =>
                          handleCheckBoxChange("Electrics", e.target.value)
                        }
                      />
                      Electrics
                    </label>
                  </div>
                  <Button
                    variant="contained"
                    className="paymint_btn "
                    onClick={() => handlePopup("Home+", "4", "textarea4")}
                  >
                    Book Repair
                  </Button>
                  <p className="members">
                    A member of the WeCare team will be in touch via email to
                    confirm your booking.
                  </p>
                </div>
                <div
                  className="box_celected_plans "
                  style={{ height: axpended ? "150px" : "auto" }}
                >
                  {axpended ? (
                    <button className="icons_expended" onClick={handelCards}>
                      {" "}
                      <ArrowBackIosRoundedIcon />
                    </button>
                  ) : null}
                  {plans?.map((item, i) => (
                    <div key={i}>
                      <div className="selected_plan_div">
                        <span>
                          <p>{item?.sel}</p>
                          <h1>
                            {item?.title} <span className="icone_name">+</span>
                          </h1>
                          <p className="m-0">{item?.ser}</p>
                        </span>
                        <img src={gas} alt="icons" />
                      </div>
                      <div className="cards_actions mt">
                        <div className="cards_actions">
                          {item?.working.map((item, i) => (
                            <div className="working" key={i}>
                              <CheckCircleOutlineRoundedIcon className="iconmark" />
                              {item}
                            </div>
                          ))}
                        </div>
                        <div className="cards_actions">
                          {item?.notworking?.map((item, i) => (
                            <div className="notwarking" key={i}>
                              <CancelOutlinedIcon className="notwar" />
                              <span className="spanundesr">{item}</span>
                            </div>
                          ))}
                        </div>
                        <div className="view_div">
                          <p>
                            Review what is covered in your WeCare policy, and
                            what is not.{" "}
                            <span onClick={handleOpen}>View here</span>
                          </p>
                          <Modal
                            open={open}
                            onClose={handleClose}
                            aria-labelledby="modal-modal-title"
                            aria-describedby="modal-modal-description"
                          >
                            <div className="modal_find">
                              <div className="find_close">
                                <IconButton onClick={handleClose}>
                                  <CloseIcon />
                                </IconButton>
                              </div>
                              <div>
                                <Tabs
                                  value={value}
                                  onChange={handleChange}
                                  aria-label="basic ta bs example"
                                  className="main_tabs"
                                >
                                  <Tab
                                    label="Covered"
                                    {...a11yProps(0)}
                                    className="tabeBtn"
                                  />
                                  <Tab
                                    label="Not Covered"
                                    {...a11yProps(1)}
                                    className="tabeBtn"
                                  />
                                </Tabs>
                              </div>
                              <div className="find_tabs">
                                <CustomTabPanel value={value} index={0}>
                                  <div className="cards_actions">
                                    {item?.working.map((item, i) => (
                                      <div className="working" key={i}>
                                        <CheckCircleOutlineRoundedIcon className="iconmark" />{" "}
                                        {item}
                                      </div>
                                    ))}
                                  </div>
                                </CustomTabPanel>
                                <CustomTabPanel value={value} index={1}>
                                  <div className="cards_actions">
                                    <div className="notwarking">
                                      <CancelOutlinedIcon className="notwar" />
                                      <span className="notcovering">
                                        Gas supply pipe, boiler flue
                                      </span>
                                    </div>
                                  </div>
                                  <div className="cards_actions">
                                    <div className="notwarking">
                                      <CancelOutlinedIcon className="notwar" />
                                      <span className="notcovering">
                                        Intermittent, pre-existing, or design
                                        faults which includes Removal of
                                        limescale, sludge or debris
                                      </span>
                                    </div>
                                  </div>
                                  <div className="cards_actions">
                                    <div className="notwarking">
                                      <CancelOutlinedIcon className="notwar" />
                                      <span className="notcovering">
                                        Please see Terms and Conditions document
                                        for full details of what's covered and
                                        what's not covered.
                                      </span>
                                    </div>
                                  </div>
                                </CustomTabPanel>
                              </div>
                              <div className="btnFounds">
                                <Button
                                  variant="outlined"
                                  onClick={handleDocumentDownload}
                                >
                                  Download Terms & Conditions
                                </Button>
                              </div>
                            </div>
                          </Modal>
                        </div>
                      </div>
                      <div className="month_div">
                         <h1>{item.isFixedPrice ? 'Total Price' : item?.month}</h1>
                        <span className="d-flex align-items-baseline">
                          <h2>{item?.price}</h2>{item.isFixedPrice ? '' : 'p/m'}
                        </span>
                      </div>
                      <p className="desc_dabid">
                        The initial direct debit payment will be requested in
                        the upcoming 14 days. Your policy agreement spans a
                        duration of 12 months.{" "}
                        {read || (
                          <span
                            className="read_btn"
                            onClick={() => setRead(true)}
                          >
                            Read More
                          </span>
                        )}
                      </p>
                      {read && (
                        <div className="read_more">
                          <p className="reading">
                            We will reach out to you well in advance of your
                            agreement renewal date. Your agreement is set to
                            renew automatically unless you opt to cancel. This
                            automatic renewal is designed to maintain continuous
                            coverage for you. If you prefer not to proceed with
                            automatic renewal, feel free to get in touch with us
                            to opt out.{" "}
                            <span
                              className="read_btn"
                              onClick={() => setRead(false)}
                            >
                              Read Less
                            </span>
                          </p>
                        </div>
                      )}
                      <div className="month_div">
                        <h1>{item?.serv}</h1>
                        <span className="d-flex align-items-baseline">
                          <h2>{item?.fee}</h2>
                        </span>
                      </div>
                      <p className="desc_dabid">
                        The service fee is the charge incurred each time you
                        seek a repair. You have the flexibility to select a plan
                        with or without a service request fee. Opting for a
                        higher service request fee lowers your monthly payments.
                      </p>
                    </div>
                  ))}
                  <button className="icons_expended_bot" onClick={handelCards}>
                    {" "}
                    <ArrowBackIosRoundedIcon />
                  </button>
                </div>
              </div>
            </div>
          </Modal>

        
        </Container>
      </div>
    </>
  );
};

export default DashboardHome;
